export function PathConnectorIcon({ color = "#2D2E2E" }: { color?: string }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.41675 23.8333C7.21167 23.8333 8.66675 22.3782 8.66675 20.5833C8.66675 18.7883 7.21167 17.3333 5.41675 17.3333C3.62182 17.3333 2.16675 18.7883 2.16675 20.5833C2.16675 22.3782 3.62182 23.8333 5.41675 23.8333ZM5.41662 21.6667C6.01493 21.6667 6.49996 21.1816 6.49996 20.5833C6.49996 19.985 6.01493 19.5 5.41662 19.5C4.81832 19.5 4.33329 19.985 4.33329 20.5833C4.33329 21.1816 4.81832 21.6667 5.41662 21.6667Z"
        fill={color}
      />
      <path
        d="M9.75 20.5833H11.0833C12.7402 20.5833 14.0833 19.2401 14.0833 17.5833V10.5833C14.0833 8.9264 15.4265 7.58325 17.0833 7.58325H22.125"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M18.4167 3.25L22.7501 7.58333L18.4167 11.9167"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}
